import React from "react"
import {Route, Redirect, withRouter, RouteComponentProps} from "react-router-dom"

/**
 * Redirects an index route (exact match of the current `match.url`) to a
 * specified child path while preserving the current query string.
 *
 * Example:
 *   If the current matched URL is `/admin` and `to="/users"`, navigating to
 *   `/admin` will redirect to `/admin/users`.
 */

export interface IndexRedirectProps extends RouteComponentProps {
  to: string
}

const IndexRedirect: React.FC<IndexRedirectProps> = ({match, to, location}) => {
  let url = "/"
  const query = location.search || ""

  if (match) {
    url = match.url
  }

  /** remove doubled up `/`'s between `url` and `to` */
  if (url.charAt(url.length - 1) === "/" && to.charAt(0) === "/") {
    url = url.slice(0, -1)
  }

  return <Route exact path={url} component={() => <Redirect to={{...location, pathname: `${url}${to}${query}`}} />} />
}

export default withRouter(IndexRedirect)
